import ReactGA from "react-ga4";
import {
    hasAnalyticsConsent,
    setGoogleAnalyticsDisabled,
} from "./CookieConsentUtils";

export function initializeGoogleAnalytics() {
    const measurementId = process.env.REACT_APP_ANALYTICS_TOKEN;
    if (!measurementId || !hasAnalyticsConsent()) return false;

    setGoogleAnalyticsDisabled(false);

    if (!ReactGA.isInitialized) {
        ReactGA.initialize(measurementId, {
            gaOptions: {send_page_view: false},
            gtagOptions: {send_page_view: false},
        });
    }

    return true;
}

export function sendAnalyticsPageView(path) {
    if (!initializeGoogleAnalytics()) return;
    ReactGA.send({hitType: "pageview", page: path});
}

export function sendAnalyticsEvent(name) {
    if (!initializeGoogleAnalytics()) return;
    ReactGA.event(name);
}
